module.exports = __webpack_public_path__ + "img/7.2d7b926d.png";